import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

const RED = '#FF8618';

/* Popup / modal gameplay video player.
   Opens on user click (from the WATCH THE PROTOTYPE GAMEPLAY area).
   Autoplays MUTED (no autoplay sound) with native controls so the
   viewer can unmute + scrub. Responsive 16:9. */
const VideoModal = ({ open, onClose, src, title = 'Prototype Gameplay' }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
      const v = videoRef.current;
      if (v) { v.pause(); }
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      className="video-modal-overlay"
      data-testid="video-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className="video-modal-content" onClick={(e) => e.stopPropagation()} data-testid="video-modal-content">
        {/* HUD corner brackets */}
        <span className="video-modal-corner tl" />
        <span className="video-modal-corner tr" />
        <span className="video-modal-corner bl" />
        <span className="video-modal-corner br" />

        <button
          onClick={onClose}
          data-testid="video-modal-close"
          className="video-modal-close"
          aria-label="Close video"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="video-modal-aspect">
          <video
            ref={videoRef}
            src={src}
            data-testid="gameplay-video"
            controls
            autoPlay
            muted
            playsInline
            preload="metadata"
            className="video-modal-video"
          />
        </div>

        <div className="video-modal-caption">
          <span className="block w-2 h-2" style={{ background: RED, transform: 'rotate(45deg)', boxShadow: '0 0 5px rgba(255,134,24,0.45)' }} />
          <span>{title}</span>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default VideoModal;
